<template>
  <div
    v-if="!isMobile"
    class="touchpoint-container"
  >
    <HeaderPill
      v-if="isHeaderPill"
      :is-enclosed-page="isEnclosedPage"
    />
  </div>
</template>
<script lang="ts">
import { defineComponent, computed } from 'vue';

import HeaderPill from '@monolith/legacy/components/header/header-pill.vue';

import useEnclosedPage from '@core/composables/use-enclosed-page';

import { TouchpointsSlot } from '@monolith/legacy/types/api/touchpoints';
import { useBreakpoints } from '@monolith/legacy/modules/design-system-candidates';

export default defineComponent({
  name: 'TouchpointContainer',
  components: {
    HeaderPill,
  },
  props: {
    slotName: {
      type: String,
      required: true,
    },
  },
  setup(props) {
    const { isEnclosedPage } = useEnclosedPage();
    const { isMobile } = useBreakpoints();

    const isHeaderPill = computed((): boolean => {
      return props.slotName === TouchpointsSlot.HeaderPill;
    });

    return {
      isEnclosedPage,
      isMobile,
      isHeaderPill,
    };
  },
});
</script>
